import { Text } from '@/components/ui/catalyst/text';

import { useRequestPage } from '../contexts/RequestPageContext';

interface PostTaskUpdateSectionProps {
  enabled: boolean;
  text: string;
  onToggle: (enabled: boolean) => void;
  onTextChange: (text: string) => void;
}

export const PostTaskUpdateSection = ({
  enabled,
  text,
  onToggle,
  onTextChange,
}: PostTaskUpdateSectionProps) => {
  const { request } = useRequestPage();

  if (!request?.task_id) return null;

  return (
    <div className="space-y-2 font-sans">
      <div className="flex items-center justify-between gap-4">
        <Text className="font-sans text-[14px] font-semibold leading-[18px] text-zinc-900">
          Post Task Update
        </Text>
        <div className="flex items-center gap-3">
          <button
            type="button"
            role="switch"
            aria-checked={enabled}
            aria-label="Toggle post task update"
            onClick={() => onToggle(!enabled)}
            className={`relative inline-flex h-[18px] w-8 items-center rounded-full border border-transparent p-[2px] transition-colors ${
              enabled ? 'bg-violet-600' : 'bg-zinc-200'
            }`}
          >
            <span
              className={`block h-[14px] w-[14px] rounded-full bg-white shadow-sm transition-transform ${
                enabled ? 'translate-x-[14px]' : 'translate-x-0'
              }`}
            />
          </button>
          <Text className="font-sans text-[12px] font-medium leading-4 text-zinc-500">
            {enabled ? 'On submit' : 'Off'}
          </Text>
        </div>
      </div>

      <textarea
        value={text}
        onChange={(event) => onTextChange(event.target.value)}
        placeholder="Submitted HIPAA authorization to this provider. Awaiting confirmation..."
        rows={1}
        className="h-14 w-full resize-none rounded-[10px] border border-zinc-200 bg-white px-4 py-4 font-sans text-[13px] leading-4 text-zinc-900 placeholder:text-zinc-400 focus:border-violet-500 focus:ring-1 focus:ring-violet-500"
      />
    </div>
  );
};
